// @owners { team: patients }
import { COLORS } from '@alto/design-library-tokens';
import { Body, Button, LandingPage } from '@alto/design-system';
import { useQueryLandingPageConfigs } from '@alto/features';
import React from 'react';
import { getImage } from '~shared/assets/images/getImage';
import { getCompanyName } from '~shared/config/getCompanyName';
import { IMG_ALT_TEXTS } from '~shared/constants';
import { OnboardingNavBarLogo } from '~web/features/onboarding/components/redesign/OnboardingNavBarLogo';

type Props = {
  readonly handleGetStarted: () => void;
  readonly loading: boolean;
  readonly tempPassword: string;
};

export const WebLandingPage = ({ handleGetStarted, loading, tempPassword }: Props) => {
  const { isFetching, welcomeBody, welcomeHeader, headerLogoUrl, partnershipName } = useQueryLandingPageConfigs({
    tempPassword,
  });
  const companyName = getCompanyName();
  // HACK: Instead of adding company ids to [`OnboardingConfig` model in scriptdash],
  // replace any mention of "Alto" in copy with the current company name.
  const title = welcomeHeader?.replace('Alto', companyName);
  const subtitleDefault = 'Extraordinary care and convenience for a healthier life.';
  const subtitle = welcomeBody?.replace('Alto', companyName) ?? subtitleDefault;

  if (isFetching) {
    return null;
  }

  return (
    <LandingPage
      withoutWebFramingElementHeights
      footerPlacementContext="webScreenWithoutPolicyFooter"
      HeaderBodyCopy={<Body>{subtitle}</Body>}
      backgroundColor={COLORS.BACKGROUND_COLORS.TERTIARY_LIGHTEST}
      NavBarCenterContent={
        <OnboardingNavBarLogo
          illustrationSrc={headerLogoUrl}
          partnershipName={partnershipName}
        />
      }
      title={title || `Welcome to ${companyName}`}
      illustrationSrc={getImage('onboardingWelcome')}
      illustrationSize="xxl"
      illustrationAccessibilityLabel={IMG_ALT_TEXTS.onboardingWelcome}
      buttons={[
        <Button
          label="Get started"
          key="get-started"
          loading={loading}
          onPress={handleGetStarted}
        />,
      ]}
    ></LandingPage>
  );
};
